import { resetAiToolbox, setDatePickerId, setShowImportFeedback, setShowSideBar, setTemplateLoadingState } from "@/store/app/slice";
import { resetPages } from "@/store/pages/slice";
import { setActiveResume } from "@/store/resume/slice";
import { AppDispatch } from "@/store/store";
import { setActiveItemId, setActiveSection, setActiveTemplate } from "@/store/template/slice";
import { TemplateLoadingState } from "@/types/app";
import { clearActiveUserJob } from "@/store/userJob/slice";

export const resetResumeBuilderState = (dispatch: AppDispatch) => {
    dispatch(setActiveItemId(null));
    dispatch(resetAiToolbox());
    dispatch(setActiveSection());
    dispatch(setActiveResume());
    dispatch(setActiveTemplate());
    dispatch(resetPages());
    dispatch(setTemplateLoadingState(TemplateLoadingState.INITIAL));
    dispatch(setShowSideBar(false));
    dispatch(setDatePickerId(""));
    dispatch(setShowImportFeedback(false));
    dispatch(clearActiveUserJob());
};